<template>
  <div v-if="selectedVehicle">
    <v-card v-if="tripReporting.length > 0">
      <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
        <card-image :title="`${selectedVehicle.plate}`" :onClick="SET_VIEW_HISTORY_DETAIL_STATE"/>
        <v-container>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card class="float-card elevation-2">
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>Di chuyển</div>
                        <div class="bold-text">{{distance}} Km</div>
                      </div>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>VT trung bình</div>
                        <div
                          :class="`bold-text ${isOverspeed(avgSpeed) ? `red--text`: `green--text`}`"
                        >{{avgSpeed}} Km/h</div>
                      </div>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4>
                      <div>
                        <div>VT tối đa</div>
                        <div
                          :class="`bold-text ${isOverspeed(maxSpeed) ? `red--text`: `green--text`}`"
                        >{{maxSpeed}} Km/h</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex md12>
                <br>
                <div class="headline">Chi tiết hành trình</div>
                <br>
                <Timeline
                  :timeline-items="timelineItems"
                  :message-when-no-items="`Không có dữ liệu`"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
      </vue-perfect-scrollbar>
    </v-card>
    <div v-else>
      <v-toolbar class="elevation-0" color="transparent">
        <v-spacer></v-spacer>
        <v-btn icon @click="SET_VIEW_HISTORY_DETAIL_STATE(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <blank
        :src="`/static/icons/blank/history.png`"
        :firstLine="`Chưa có dữ liệu`"
        :secondLine="`Dữ liệu hành trình sẽ được hiển thị tại đây khi xe bắt đầu di chuyển`"
        :width="240"
      />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CardImage from '@/components/images/cardimage';
import Timeline from '@/components/Timeline/Timeline';
import Blank from '@/components/Blank';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as MapUtil from '@/utils/maputil';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  name: 'history-detail-list',
  components: {
    VuePerfectScrollbar,
    CardImage,
    Timeline,
    Blank
  },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 160
      }
    };
  },
  computed: {
    ...mapGetters(['selectedVehicle', 'tripReporting']),
    historyWaypoints () {
      let trips = [];
      if (this.tripReporting.length > 0) {
        this.tripReporting.map(a => {
          trips = trips.concat(a.points);
          return 0;
        });
      }
      return trips;
    },
    distance () {
      let total = 0;
      this.tripReporting.map(a => {
        total += a.km;
        return 0;
      });
      return total > 0 ? total.toFixed(2) : 0;
    },
    avgSpeed () {
      let totalSpeed = 0;
      this.historyWaypoints.map(a => {
        totalSpeed += a.kmh;
        return 0;
      });
      return totalSpeed > 0
        ? (totalSpeed / this.historyWaypoints.length).toFixed(2)
        : 0;
    },
    maxSpeed () {
      let maxSpeed = 0;
      this.historyWaypoints.map(a => {
        maxSpeed = a.kmh > maxSpeed ? a.kmh : maxSpeed;
        return 0;
      });
      return maxSpeed;
    },
    timelineItems () {
      let timeline = [
        {
          items: []
        }
      ];

      this.tripReporting.map((trip, index) => {
        let startPoint = trip.points[0];
        let endPoint = trip.points[trip.points.length - 1];

        // Add start item
        if (index === 0) {
          let startItem = {
            time: DateTimeUtil.formatSecondToHHmm(startPoint.time),
            color: 'orange'
          };
          startItem.title = 'Bắt đầu';
          startItem.description = MapUtil.getAddressFromWaypoint(startPoint);
          timeline[0].items.push(startItem);
        }

        // Add moving item
        let movingItem = {
          time: DateTimeUtil.formatSecondToHHmm(startPoint.time),
          color: 'green'
        };

        let totalDistance = (endPoint.kmage - startPoint.kmage).toFixed(2);
        let totalTime = DateTimeUtil.formatSecondToDuration(
          endPoint.time - startPoint.time
        );

        let totalSpeed = 0;
        let maxSpeed = 0;
        let count = 0;

        trip.points.map(point => {
          totalSpeed += point.kmh;
          maxSpeed = point.kmh > maxSpeed ? point.kmh : maxSpeed;
          count++;
          return 0;
        });

        let avgSpeed = (totalSpeed / count).toFixed(2);

        movingItem.title = `Di chuyển ${totalDistance} km trong ${totalTime}`;
        movingItem.description = `Vận tốc TB: ${avgSpeed} km/h, tối đa: ${maxSpeed} km/h`;
        timeline[0].items.push(movingItem);

        // Add stopped item
        let stoppedItem = {
          time: DateTimeUtil.formatSecondToHHmm(endPoint.time),
          color: 'orange'
        };
        let duration = DateTimeUtil.formatSecondToDuration(
          trip.nextTripStart.time - endPoint.time
        );
        stoppedItem.description = MapUtil.getAddressFromWaypoint(endPoint);

        if (index < this.tripReporting.length - 1) {
          stoppedItem.title = `Dừng ${duration}`;
        } else {
          stoppedItem.title = `Kết thúc`;
        }

        timeline[0].items.push(stoppedItem);

        return 0;
      });

      return timeline;
    }
  },
  methods: {
    ...mapMutations(['SET_VIEW_HISTORY_DETAIL_STATE']),
    isOverspeed (speed) {
      return speed > (this.selectedVehicle.maxSpeed || 999);
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 64px);
  overflow: auto;
}
.float-card {
  margin-top: 56px;
  padding: 8px;
}
.bold-text {
  font-weight: bold;
  font-size: 14pt;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/components/historydetail.vue